module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('article', {
    staticClass: "posts"
  }, [(_vm.title !== '') ? _c('h1', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.question !== '') ? _c('div', {
    staticClass: "question",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledQuestion)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post !== '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.compiledPost)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content !== '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.compiledContent)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-163215c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Post.vue
// module id = 122
// module chunks = 2